import { render, staticRenderFns } from "./ReleaseTracksLinkButton.vue?vue&type=template&id=6363dbb0&"
import script from "./ReleaseTracksLinkButton.vue?vue&type=script&lang=js&"
export * from "./ReleaseTracksLinkButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports